import { typography } from '@/styles';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const Body1 = styled.span`
    ${typography.sansSerif}

    font-size: 14px;
    font-weight: 700;
    text-wrap: nowrap;
`;
